import { VisuallyHidden as ChakraVisuallyHidden } from "@chakra-ui/react";

export default function VisuallyHidden({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element {
  return <ChakraVisuallyHidden>{children}</ChakraVisuallyHidden>;
}
